module.exports = __webpack_public_path__ + "./favicons/favicon-96x96.png";